module.exports = __webpack_public_path__ + "img/apple-store.d467c972.png";